import {
  AUTH_LOGIN,
  AUTH_LOGOUT, CHANGE_USER_WORK_STATUS,
  CREATE_USER, DELETE_USER,
  EDIT_BALANCE, EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT,
} from './user';
import {
  LOAD_SETTINGS, LOAD_EXCHANGE_INFO,
  UPDATE_SETTING, LOAD_STATS, LOAD_ACTIONS_STATS, LOAD_RATES, UPDATE_RATE_SOURCE
} from "./settings";
import {
  CANCEL_CLAIM, CANCEL_ORDER,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ORDERS_LIST,
  OPEN_CLAIM, REFINISH_ORDER, RESTART_FINISH_ERROR_ORDERS, SWITCH_NOTE,
} from './orders';
import { LOAD_CLAIMS } from "./claims";
import {
  ADD_TEMPLATE, CHAT_SEARCH,
  CHAT_SEND_MESSAGE, CLOSE_TICKET,
  DELETE_TEMPLATE,
  EDIT_TEMPLATE,
  LOAD_CHAT,
  LOAD_CHATS_LIST,
  LOAD_TEMPLATES
} from "./chats";
import {
  ADD_BLACK_LIST_REQUISITE,
  ADD_BLACK_LIST_USER, DELETE_BLACK_LIST_REQUISITE,
  DELETE_BLACK_LIST_USER, LOAD_EXCHANGE_SETTINGS,
  LOAD_BLACK_LIST_REQUISITES,
  LOAD_BLACK_LIST_USERS, EDIT_EXCHANGE_SETTINGS, ADD_USER_NOTE, DELETE_USER_NOTE,
} from './exchange';


const path = {
  [AUTH_LOGIN]: '/users/login',
  [AUTH_LOGOUT]: '/users/logout',
  [LOAD_USERS_LIST]: '/users',
  [CREATE_USER]: '/users',
  [EDIT_USER]: '/users',
  [EDIT_BALANCE]: '/users/balance',
  [EDIT_SUPPORT_LIMIT]: '/users/limit/edit',
  [RESET_SUPPORT_LIMIT]: '/users/limit/reset',
  [DELETE_USER]: '/users',
  [LOAD_ORDERS_LIST]: '/orders',
  [EDIT_ORDER]: '/orders/:id:',
  [FINISH_ORDER]: '/orders/:id:/finish',
  [REFINISH_ORDER]: '/orders/:id:/refinish',
  [CANCEL_ORDER]: '/orders/:id:/cancel',
  [LOAD_SETTINGS]: '/settings/global',
  [LOAD_EXCHANGE_SETTINGS]: '/exchange/settings',
  [EDIT_EXCHANGE_SETTINGS]: '/exchange/settings',
  [UPDATE_SETTING]: '/settings/global',
  [OPEN_CLAIM]: '/claims/:id:/claim',
  [CANCEL_CLAIM]: '/claims/:id:/claim',
  [LOAD_CLAIMS]: '/claims/:category:',
  [CHANGE_USER_WORK_STATUS]: '/users/settings/work_status/:status:',
  [LOAD_EXCHANGE_INFO]: '/exchange/info',
  [LOAD_CHATS_LIST]: '/chats',
  [LOAD_CHAT]: '/chats/:id:',
  [CHAT_SEND_MESSAGE]: '/chats/:id:/send',
  [LOAD_TEMPLATES]: '/chats/settings/templates',
  [ADD_TEMPLATE]: '/chats/settings/templates',
  [EDIT_TEMPLATE]: '/chats/settings/templates/:id:',
  [DELETE_TEMPLATE]: '/chats/settings/templates/:id:',
  [CHAT_SEARCH]: '/chats/search/:mode:',
  [CLOSE_TICKET]: '/chats/:id:/close',
  [LOAD_STATS]: '/orders/stats',
  [LOAD_ACTIONS_STATS]: '/users/actions',
  [LOAD_BLACK_LIST_USERS]: '/blacklist/users',
  [ADD_BLACK_LIST_USER]: '/blacklist/users',
  [DELETE_BLACK_LIST_USER]: '/blacklist/users',
  [LOAD_BLACK_LIST_REQUISITES]: '/blacklist/requisites',
  [ADD_BLACK_LIST_REQUISITE]: '/blacklist/requisites',
  [DELETE_BLACK_LIST_REQUISITE]: '/blacklist/requisites',
  [SWITCH_NOTE]: '/orders/:id:/notes/:type:',
  [RESTART_FINISH_ERROR_ORDERS]: '/service/orders/restart-finish-error',
  [ADD_USER_NOTE]: '/notes/users',
  [DELETE_USER_NOTE]: '/notes/users',
  [LOAD_RATES]: '/rates',
  [UPDATE_RATE_SOURCE]: '/rates/source',
};
export default path;
